import React, { ReactNode } from 'react';
import { Typography } from 'antd';

import { CandidateConsentStatus } from './Consents.types';

export const FormattedCandidateConsentStatus: React.FC<{ status: CandidateConsentStatus }> = ({ status }) => {
  return <>{candidateConsentStatusMap[status]}</>;
};

const candidateConsentStatusMap: Record<CandidateConsentStatus, ReactNode> = {
  PENDING_APPROVAL: (
    <Typography.Text strong style={{ color: '#4D88FF' }}>
      Pending approval
    </Typography.Text>
  ),
  APPROVED: (
    <Typography.Text strong type="success">
      Approved
    </Typography.Text>
  ),
  RENEWED: (
    <Typography.Text strong type="success">
      Renewed
    </Typography.Text>
  ),
  REVOKED: (
    <Typography.Text strong type="danger">
      Revoked
    </Typography.Text>
  ),
  EXPIRED: (
    <Typography.Text strong type="danger">
      Expired
    </Typography.Text>
  ),
};
